export default function useResponseParser() {

    const parseData = (response: any) => {
        return response.data.data
    }
    return parseData
}